export const EmptyReferrals: React.FC = () => {
    return (
        <>
            <div>No Referrals Found</div>
        </>
    );
};
